import React from "react";

const BoxLoader = ({
  className,
  type,
}: {
  className?: string;
  type?: string;
}) => {
  return (
    <div
      className={`box-loader ${type === "cover" ? "cover-mode" : ""} ${
        className || ""
      }`}
    ></div>
  );
};

export default React.memo(BoxLoader);
